function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCircleBackground = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  fill: "currentColor",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  },
  viewBox: "0 0 838 1253"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: 209.5,
  cy: 225.614,
  r: 209.5,
  style: {
    fill: "#29484e"
  },
  transform: "scale(2.00042)"
}));
export default SvgCircleBackground;